module.exports = __webpack_public_path__ + "img/anba.14c9501b.jpg";